// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpandToggle-expandContainer-z7kzB {
  height: 38px;
  -webkit-box-shadow: 0px 8px 11px #3131310F;
          box-shadow: 0px 8px 11px #3131310F;
  border-radius: 6px;
  position: absolute;
  top: 25px;
  left: 25px;
  z-index: 2;
  background: var(--primary-white-bg);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  cursor: pointer;
  padding: 0 15px;
}

.ExpandToggle-expandContent-j2lna {
  display: inline-block;
  margin: 0 7px;
  position: relative;
  cursor: pointer;
  font-weight: 500;
}

.ExpandToggle-expandContainer-z7kzB img {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.ExpandToggle-exPandIcon-R5Id7 {
  position: relative;
  width: 14px;
  height: 11px;
}

.ExpandToggle-listingIcon-QEIgk {
  position: relative;
  top: 1px;
}

@media screen and (max-width: 1199px) {
  .ExpandToggle-expandContainer-z7kzB {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/ExpandToggle/ExpandToggle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0CAAkC;UAAlC,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,mCAAmC;EACnC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".expandContainer {\n  height: 38px;\n  box-shadow: 0px 8px 11px #3131310F;\n  border-radius: 6px;\n  position: absolute;\n  top: 25px;\n  left: 25px;\n  z-index: 2;\n  background: var(--primary-white-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0 15px;\n}\n\n.expandContent {\n  display: inline-block;\n  margin: 0 7px;\n  position: relative;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.expandContainer img {\n  transition: all 0.3s ease;\n}\n\n.exPandIcon {\n  position: relative;\n  width: 14px;\n  height: 11px;\n}\n\n.listingIcon {\n  position: relative;\n  top: 1px;\n}\n\n@media screen and (max-width: 1199px) {\n  .expandContainer {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expandContainer": `ExpandToggle-expandContainer-z7kzB`,
	"expandContent": `ExpandToggle-expandContent-j2lna`,
	"exPandIcon": `ExpandToggle-exPandIcon-R5Id7`,
	"listingIcon": `ExpandToggle-listingIcon-QEIgk`
};
module.exports = ___CSS_LOADER_EXPORT___;
